export const authorAction = {
  GET_AUTHOR: 'GET_AUTHOR',
};
export const authorMutation = {
  SET_AUTHOR: 'SET_AUTHOR',
  CLEAR_AUTHOR: 'CLEAR_AUTHOR',
};
export const AuthorModule = 'author';
